export const normalizeVehicleNumber = (value = '') => String(value || '')
  .toUpperCase()
  .replace(/[^A-Z0-9]/g, '')
  .slice(0, 11);

export const formatVehicleNumber = (value = '') => {
  const normalized = normalizeVehicleNumber(value);
  if (!normalized) return '';

  if (normalized.length === 11) {
    return [
      normalized.slice(0, 2),
      normalized.slice(2, 4),
      normalized.slice(4, 7),
      normalized.slice(7, 11)
    ].join('-');
  }

  return [
    normalized.slice(0, 2),
    normalized.slice(2, 4),
    normalized.slice(4, 6),
    normalized.slice(6, 10)
  ]
    .filter(Boolean)
    .join('-');
};
